export default "__VITE_ASSET__BVE5vdHt__"